import { useState } from 'react';
import { CustomerTypeChooser } from './CustomerTypeChooser';
import { CustomerFormParticular } from './CustomerFormParticular';
import { CustomerFormBusiness } from './CustomerFormBusiness';
import type { Customer, CreateCustomerInput } from '../types/customer.types';

interface CustomerFormProps {
  customer?: Customer;
  onSubmit: (data: CreateCustomerInput) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

/**
 * Router del formulario de cliente — reemplaza al formulario único que
 * mezclaba Particular/Comercial en un solo esquema (mdl17). El portal legado
 * (`EditAndCreateCustomerForm.cshtml`) tiene DOS formularios distintos según
 * el tipo de cliente:
 *   - Alta nueva: primero pregunta el tipo (`CustomerTypeChooser`), luego
 *     muestra el formulario correspondiente.
 *   - Edición: el tipo ya está definido por `customer.customerKind` — se
 *     entra directo al formulario correcto, sin volver a preguntar.
 */
export function CustomerForm({ customer, onSubmit, onCancel, isLoading }: CustomerFormProps) {
  const [chosenKind, setChosenKind] = useState<'PARTICULAR' | 'BUSINESS' | null>(
    customer?.customerKind ?? null
  );

  if (!chosenKind) {
    return <CustomerTypeChooser onSelect={setChosenKind} onCancel={onCancel} />;
  }

  if (chosenKind === 'BUSINESS') {
    return (
      <CustomerFormBusiness
        customer={customer?.customerKind === 'BUSINESS' ? customer : undefined}
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
      />
    );
  }

  return (
    <CustomerFormParticular
      customer={customer?.customerKind === 'PARTICULAR' ? customer : undefined}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  );
}
